import { cdnUrl } from '../config/environment';
import { ArticleImage } from '../interfaces/ArticleImage';

export const normalizeArticleNumber = (artNumber: string) =>
  artNumber.replace(/\s/g, '_').replace('/', '_');

export const getModelUrl = (articleNumber: string) =>
  `${cdnUrl}/models/${normalizeArticleNumber(articleNumber)}.glb`;
export const getModelCustomUrl = (name: string) => `${cdnUrl}${name}`;
export const getVideoUrl = (articleNumber: string) =>
  `${cdnUrl}/videos/${normalizeArticleNumber(articleNumber)}.mp4`;
export const getImageUrl = (articleNumber: string) =>
  `${cdnUrl}/images/${normalizeArticleNumber(articleNumber)}.png`;
export const getThumbnailUrl = (images: ArticleImage[]) => {
  let imageUrl;
  if (images) {
    images.forEach((image) => {
      if (image.urls && image.displayOrder === 1) {
        image.urls.forEach((url) => {
          if (url.resolution === 'JPG_120') {
            imageUrl = url.url;
          }
        });
      }
    });
  }
  return imageUrl;
};
export const getTextureUrl = (texture: string) => `${cdnUrl}/textures/${texture}`;
